import { NormalizedOptions, Options as KyOptions } from 'ky';
import Cookies from 'js-cookie';

const DEFAULT_OPTION: KyOptions = {
  prefixUrl: `${
    process.env.REACT_APP_API_SERVER_URL || 'http://localhost:3001'
  }/api/v1`,
  timeout: 5000,
  retry: 2,
  headers: { 'Content-Type': 'application/json' },
  throwHttpErrors: false,
  hooks: {
    afterResponse: [
      (
        _request: Request,
        _options: NormalizedOptions,
        response: Response,
      ): Response => {
        const { headers } = response;
        const accessToken = headers.get('access-token');
        const client = headers.get('client');
        const uid = headers.get('uid');
        const expiry = headers.get('expiry');
        if (accessToken && client && uid && expiry) {
          Cookies.set('_accessToken', accessToken);
          Cookies.set('_client', client);
          Cookies.set('_uid', uid);
          Cookies.set('_expiry', expiry);
        }

        return response;
      },
    ],
  },
};

export default DEFAULT_OPTION;
